import { createApp } from 'vue'
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'; 
// import VueHtml2Canvas from 'vue-html2canvas';
import router from './router/index.js';
import store from './store/index.js';
import App from './App.vue'

library.add(faCircleXmark);


// import './registerServiceWorker.js';

if (process.env.NODE_ENV === 'production') {
  // if ('serviceWorker' in navigator) {
  //   // Use the window load event to keep the page load performant
  //     window.addEventListener('load', () => {
  //       navigator.serviceWorker.register('sw.js', {scope: './'})
  //       .then(() => {
  //         // registration worked
  //         console.log("Registration succeeded.")});
  //     });
  // }
}

const app = createApp(App).use(store)
app.use(message)

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
// app.use(VueHtml2Canvas);

app.mount('#app')